module.exports = __webpack_public_path__ + "img/t_0020.8a7998f3.gif";